export default __webpack_public_path__ + "static/media/cn.d603a965.svg";